// Utility to update or add a query param in a search string
export function updateQueryParam(search: string, key: string, value: string) {
  const params = new URLSearchParams(search);
  params.set(key, value);
  return params.toString();
}
